import { Box, Button, Drawer, Hidden, List, ListItemButton, ListItemText, Paper, Stack, Theme, Typography, useTheme } from '@mui/material';
import { useMemo, useState } from 'react';
import { CommonLayout } from '../../commonComponents';
import { Redirect, Route, Switch, useHistory, Router, useRouteMatch } from 'react-router-dom';
import { AnimatedBox, ReportLeftLayout, SectionLinkItem } from '../../InvestorReport/index';
import { HoldingReport } from './holding-report';
import { MFTransactionWiseHoldingReport } from './MF-Transactionwise-holding-report';
import { CapitalGainStatement } from './capital-gain-statement';
import { TransactionHistoryReport } from './transaction-history-report';
import { PortfolioReportIcon, RMHoldingReportIcon, ReportsCGSDisabledIcon, ReportsClientStatementIcon, ReportsHoldingDisabledIcon, ReportsMFTxnIconDisabled, ReportsTxnHistoryDisabledIcon, ReportsTxnStatIcon, RiaReportActiveIcon, RiaReportInActiveIcon } from '../../../assets/SvgIcons';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ClientStatement } from './ClientStatement';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import BreadCrum from '../../../lib/BreadCrum';
import { USER_ROLES } from '../../../utils/constant';
import { isModuleAllowed } from '../../../utils/utilityFunctions';
// import RiaReport from './RiaReport';
import CorporateActionReport from './CorporateActionReport';

interface MenuItem {
  title: string;
  routerLink: string;
  activeIcon: JSX.Element;
  icon: JSX.Element;
  isDisabled: boolean;
  renderComponent: JSX.Element;
}

const DrawerList = ({
  currentMenuItem,
  setCurrentMenuItem,
  leftMenuItem,
  setOpenDrawer,
}: {
  currentMenuItem: string,
  setCurrentMenuItem: React.Dispatch<React.SetStateAction<string>>,
  leftMenuItem: Array<MenuItem>,
  setOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>,
}) => {
  const history = useHistory();
  const { path } = useRouteMatch();

  const handleClick = (item: MenuItem) => {
    setOpenDrawer(false)
    setCurrentMenuItem(item.title)
    history.push(`${path}/${item.routerLink}`)
  }

  return (
    <List sx={{ padding: '10px 20px' }}>
      {leftMenuItem.map((item: MenuItem) => (
        <ListItemButton
          key={item.title}
          onClick={() => handleClick(item)}
          sx={{
            display: 'flex',
            alignItems: 'center',
            columnGap: '15px'
          }}
        >
          {currentMenuItem === item.title ? item.activeIcon : item.icon}
          <ListItemText>
            {item?.title ?? ""}
          </ListItemText>
        </ListItemButton>
      ))}
    </List>
  )
}

export default function DashboardReportRoute(): JSX.Element {
  const history = useHistory();
  const pathName = history.location.pathname;
  const { path } = useRouteMatch();
  const theme = useTheme();
  // Data from redux store
  const { role = '', permissions = [] } = useSelector((state: RootStateType) => state.auth);

  // State
  const [isSideSectionDisabled, setSideSectionDisabled] = useState<boolean>(false)
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);

  const handleSideSectionDisabled = (value: boolean) => {
    setSideSectionDisabled(value)
  }

  const leftMenuItem: Array<MenuItem> = useMemo(() => [
    {
      title: 'Client Statement',
      routerLink: `mf-client-statement`,
      activeIcon: <ReportsClientStatementIcon />,
      icon: <ReportsMFTxnIconDisabled />,
      isDisabled: false,
      renderComponent: <ClientStatement handleSideSectionDisabled={handleSideSectionDisabled} />
    },
    {
      title: 'MF Transaction-wise Holding Report',
      routerLink: `mf-transaction-wise-holding-report`,
      activeIcon: <ReportsClientStatementIcon />,
      icon: <ReportsMFTxnIconDisabled />,
      isDisabled: false,
      renderComponent: <MFTransactionWiseHoldingReport handleSideSectionDisabled={handleSideSectionDisabled} />
    },
    {
      title: 'Holding Report',
      routerLink: `holding-report`,
      activeIcon: <RMHoldingReportIcon />,
      icon: <ReportsHoldingDisabledIcon />,
      isDisabled: false,
      renderComponent: <HoldingReport handleSideSectionDisabled={handleSideSectionDisabled} />
    },
    {
      title: 'Capital Gain Statement',
      routerLink: `capital-gain-statement`,
      activeIcon: <PortfolioReportIcon />,
      icon: <ReportsCGSDisabledIcon />,
      isDisabled: false,
      renderComponent: <CapitalGainStatement handleSideSectionDisabled={handleSideSectionDisabled} />
    },
    {
      title: 'Transaction History Report',
      routerLink: `transaction-history-report`,
      activeIcon: <ReportsTxnStatIcon />,
      icon: <ReportsTxnHistoryDisabledIcon />,
      isDisabled: false,
      renderComponent: <TransactionHistoryReport handleSideSectionDisabled={handleSideSectionDisabled} />
    },
    // {
    //   title: 'Detailed Holding Report',
    //   routerLink: `DetailedHoldingReport`,
    //   activeIcon: <ReportsTxnStatIcon />,
    //   icon: <ReportsDetailedHoldingDisabledIcon />,
    //   isDisabled: false,
    //   renderComponent: <DetailedHoldingReport handleSideSectionDisabled={handleSideSectionDisabled} />
    // },
    ...(isModuleAllowed({ value: "CAReportDownload", compareArr: permissions, objKey: "permissonCode" }) ? [{
      title: 'Corporate Action Report',
      routerLink: `corporate-action-report`,
      activeIcon: <RMHoldingReportIcon />,
      icon: <ReportsHoldingDisabledIcon />,
      isDisabled: false,
      renderComponent: <CorporateActionReport handleSideSectionDisabled={handleSideSectionDisabled} />
    }] : [])
    // {
    //   title: 'RIA Report',
    //   routerLink: 'ria-report',
    //   activeIcon: <RiaReportActiveIcon />,
    //   icon: <RiaReportInActiveIcon />,
    //   isDisabled: false,
    //   renderComponent: <RiaReport handleSideSectionDisabled={handleSideSectionDisabled} />
    // }
  ], []);

  const currentPath = pathName.split('/');
  const menuPath = leftMenuItem?.find(item => item.routerLink === currentPath[2])?.title

  // States
  const [currentMenuItem, setCurrentMenuItem] = useState<string>(menuPath ? menuPath : `${leftMenuItem.find(item => !item.isDisabled)?.title ?? leftMenuItem[0].title} `);

  const rmRouterPath = (isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" }) ? [
    {
      name: 'Dashboard',
      path: '/dashboard',
    },
    {
      name: `Reports`,
      path: '/reports-download',
    },
  ] : [])

  return (
    <CommonLayout>
      <>
        <Box
          sx={{
            width: ['100%', '100%', '100%'],
            pt: [0, 0, 0],
            pb: [0, 0, '60px'],
            boxSizing: 'border-box',
          }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-end"
            sx={{ mb: "25px", display: ['none', 'flex', 'flex'] }}>
            {![USER_ROLES.INVESTOR].includes(role) ? (
              <BreadCrum array={rmRouterPath} />
            ) :
              <Typography
                variant='h1'
                sx={{
                  color: 'text.primary',
                  lineHeight: '32.5px'
                }}>
                Reports
              </Typography>
            }
          </Stack>
          <Hidden smUp={true}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-end"
              sx={{ display: ['flex', 'flex', 'flex'] }}>
              {![USER_ROLES.INVESTOR].includes(role) ? (
                <BreadCrum array={rmRouterPath} />
              ) :
                <Typography
                  variant='h1'
                  sx={{
                    color: 'text.primary',
                    lineHeight: '32.5px'
                  }}>
                  Reports
                </Typography>
              }
            </Stack>
            <Button
              sx={(theme: Theme) => (
                {
                  my: 3,
                  p: '20px 18px',
                  background: theme.palette.common.white,
                  borderRadius: '20px',
                  cursor: isSideSectionDisabled ? 'not-allowed' : 'pointer',
                  opacity: isSideSectionDisabled ? 0.5 : 1,
                  width: '100%'
                }
              )}
              onClick={() => {
                if (!isSideSectionDisabled) {
                  setOpenDrawer(true)
                }
              }}
            >
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
                  {(leftMenuItem ?? []).find((obj: MenuItem) => obj.title === currentMenuItem)?.activeIcon}
                  <Typography
                    variant='subtitle_500'
                    sx={(theme: Theme) => ({
                      color: theme.palette.primary[500],
                      letterSpacing: '0.02px'
                    })}
                  >
                    {currentMenuItem}
                  </Typography>
                </Box>
                <ExpandMoreIcon sx={{ color: theme.palette.common.black }}/>
              </Box>
            </Button>
          </Hidden>
          <Paper
            sx={{
              p: '25px',
              boxShadow: '0,0,0,rgba(0,0,0,0.05)',
              borderRadius: [0, 0, '25px'],
              height: ['auto', 'auto', 'auto'],
            }}>
            <Stack direction="row" sx={{ width: '100%' }}>
              <Hidden only="xs">
                <ReportLeftLayout>
                  <Box
                    component="ol"
                    role="list"
                    sx={{
                      listStyle: 'none',
                      m: 0,
                      p: 0,
                    }}
                  >
                    {leftMenuItem.map((item) => (
                      <Box
                        component="li"
                        role="listitem"
                        key={item.title}
                        sx={{
                          listStyle: 'none',
                          display: 'block',
                        }}
                      >
                        <SectionLinkItem
                          to={{ pathname: `${path}/${item.routerLink}` }}
                          title={item.title}
                          icon={item.icon}
                          disabled={item.isDisabled || isSideSectionDisabled}
                        />
                      </Box>
                    ))}
                  </Box>
                </ReportLeftLayout>
              </Hidden>
              <AnimatedBox
                sx={{
                  minWidth: "200px",
                  flex: 2
                }}
              >
                <Box
                  sx={(theme: Theme) => ({
                    border: `1px solid ${theme.palette.text.secondary}26`,
                    padding: '35px',
                    borderRadius: '15px',
                  })}
                >
                  <Router history={history}>
                    <Switch>
                      <Redirect
                        exact
                        from={path}
                        to={{
                          pathname: `${path}/mf-client-statement`,
                        }}
                      />
                      {leftMenuItem.map((item) => (
                        <Route
                          key={item.title}
                          path={`${path}/${item.routerLink}`}
                          render={() => item.renderComponent}
                        />
                      ))}
                    </Switch>
                  </Router>
                </Box>
              </AnimatedBox>
            </Stack >
          </Paper >
        </Box >

        {/* Drawer */}
        < Drawer
          anchor='bottom'
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
          sx={{
            borderRadius: '25px 25px 0px 0px',
            ".MuiPaper-elevation": {
              borderRadius: '25px 25px 0px 0px'
            }
          }}
        >
          <DrawerList
            currentMenuItem={currentMenuItem}
            setCurrentMenuItem={setCurrentMenuItem}
            leftMenuItem={leftMenuItem}
            setOpenDrawer={setOpenDrawer}
          />
        </Drawer >
      </>
    </CommonLayout >
  );
}
